import { v4 as uuidv4 } from 'uuid';
import elemento_tipo_model from '@/shared/models/elemento_tipo_model';
import forma_model from '@/shared/models/forma_model';
import material_prima_familia_model from '@/shared/models/materia_prima_familia_model';
import suaje_model from '@/shared/models/suaje_model';
import technical_specification_elemento_proceso_model from './technical_specification_elemento_proceso_model';

export default {
  AnchoTotal: 0,
  AltoTotal: 0,
  AnchoMaterial: 0,
  Base: 0,
  CantidadCambios: 0,
  CantidadColoresAdhesivo: 0,
  CantidadColoresFrente: 0,
  CantidadColoresLiner: 0,
  CantidadPolimeros: null,
  Codigo: null,
  CodigoCentro: null,
  CodigoElementoTipo: null,
  CodigoMateriaPrimaFamilia: null,
  CodigoForma: 1,
  CodigoEspecificacionTecnica: null,
  CodigoSuaje: null,
  CodigoAdaptador: null,
  Desarrollo: 0,
  ElementoTipo: { ...elemento_tipo_model },
  Engranaje: 0,
  EspecificacionTecnicaElementoProceso: [
    { ...technical_specification_elemento_proceso_model, id: uuidv4() },
  ],
  // EspecificacionTecnicaElementoTinta: [],
  EtiquetasDesarrollo: 0,
  EtiquetasEje: 0,
  EtiquetasPaso: null,
  Forma: { ...forma_model },
  GapDesarrollo: 0,
  GapEje: 0,
  ItemElemento: 1,
  AnchoMinimoMaterial: 0,
  LargoMinimoMaterial: 0,
  MargenSuperior: 0,
  MateriaPrimaFamilia: { ...material_prima_familia_model },
  MedidaDesarrollo: 0,
  MedidaEje: 0,
  Paginas: null,
  PaquetesPorCaja: null,
  PiezasPorPresentacion: null,
  RotacionImposicion: null,
  Sellado: 0,
  Solapa: 0,
  Presentacion: null,
  Suaje: { ...suaje_model },
  Adaptador: null,
  TroquelNuevo: null, //boolean
  UnidadMedida: 'mm',
};
